// 3 мес / 6 мес / 1 год / Все таб-переключатель для s6 BiomarkerDetail.
// Source: docs/specs/sprint-5/stage-4-frontend.md §4.4.

import { cn } from '@/lib/utils';
import type { TimelinePeriod } from '@/api/types';

const LABELS: Record<TimelinePeriod, string> = {
  '3m': '3 мес',
  '6m': '6 мес',
  '1y': '1 год',
  all: 'Все',
};

const ORDER: TimelinePeriod[] = ['3m', '6m', '1y', 'all'];

type Props = {
  value: TimelinePeriod;
  onChange: (period: TimelinePeriod) => void;
};

export function PeriodSelector({ value, onChange }: Props) {
  return (
    <div className="flex gap-2">
      {ORDER.map((p) => {
        const active = p === value;
        return (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={cn(
              'rounded-full px-3 py-1 text-xs',
              active ? 'bg-primary text-primary-foreground' : 'bg-muted text-gray-700',
            )}
            aria-pressed={active}
          >
            {LABELS[p]}
          </button>
        );
      })}
    </div>
  );
}
